import { clearEgressServiceEventDetails, fetchEgressServiceEventFail, fetchEgressServiceEventStarted, fetchEgressServiceEventSuccess } from '../../../reducer/services/ServiceEgressEventReducer';
import {
  ClearEgressServiceEvent,
  FetchEgressServiceEventFailure,
  FetchEgressServiceEventFailurePayload,
  FetchEgressServiceEventStarted,
  FetchEgressServiceEventSuccess,
  FetchServiceEventSuccessPayload
} from '../../types/services/GetAllServiceEventTypes';

/**
 * Fetch service event started saga action
 * @returns service event started action
 */
export const getEgressServiceEventStarted = (): FetchEgressServiceEventStarted => ({
  type: fetchEgressServiceEventStarted.type
});

/**
 * Fetch service event success saga action
 * @param payload : Service Event data
 * @returns success action
 */
export const getEgressServiceEventSuccess = (
  payload: FetchServiceEventSuccessPayload
): FetchEgressServiceEventSuccess => ({
  type: fetchEgressServiceEventSuccess.type,
  payload
});

/**
 * Fetch Service Event Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchEgressServiceEventFailure = (
  payload: FetchEgressServiceEventFailurePayload
): FetchEgressServiceEventFailure => ({
  type: fetchEgressServiceEventFail.type,
  payload
});

/**
 * Clear Service Events saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearEgressServiceEvent = (): ClearEgressServiceEvent => ({
  type: clearEgressServiceEventDetails.type
});
